module.exports = __webpack_public_path__ + "media/images/flags/GP-a2f4636c8ff3a5a5e00361571307a556.svg";